// extracted by mini-css-extract-plugin
module.exports = {"loginLeftSection":"LoginLeftSection_loginLeftSection__RHW9K"};